import Record from "./base"

export class ApplicantResponse extends Record {
  constructor(...args) {
    super(...args)
    const [model, props] = args
  }
}
